<div style="position: relative;">
    <header>
        <div class="header">
            <div style="width:85%">
                {{heading}}
            </div>

        </div>
    </header>
    <app-audio [playAudio]="playAudio"></app-audio>

    <div class="body" *ngIf="!isFindBookingInfoEnabled">
        <div class="col-md-12">
            <form [formGroup]="addForm">

                <div class="content">

                    <div class="input">
                        <label class="catlabel">Renban</label>
                        <div *ngIf="eventType == 'ADD'">
                            <select class="drpdown col-5 form-control-sm inptwdth" formControlName="renban"
                                [ngClass]="{'is-invalid': submitted && f['renban'].errors}">
                                <option value="" selected disabled hidden></option>
                                <option *ngFor="let renban of renbanData" [value]="renban.renbanno">
                                    {{renban.renbanno}}
                                </option>
                            </select>
                        </div>
                        <div *ngIf="eventType == 'Edit'">
                            <input type="text" formControlName="renban" class="form-control inptwdth"
                                [ngClass]="{'is-invalid': submitted && f['renban'].errors}" readonly>
                        </div>
                        <div *ngIf="submitted && f['renban'].errors" class="invalidFormat">
                            <div *ngIf="f['renban'].errors['required']">Renban is required</div>
                        </div>
                    </div>

                    <div class="input">
                        <label class="catlabel">Waybill Number</label>
                        <span>
                            <input type="text" formControlName="wayBillNumber" class="form-control inptwdth"
                                [ngClass]="{'is-invalid': submitted && f['wayBillNumber'].errors}">
                        </span>
                        <div *ngIf="submitted && f['wayBillNumber'].errors" class="invalidFormat">
                            <div *ngIf="f['wayBillNumber'].errors['required']">Waybill Number is required</div>
                        </div>
                    </div>
                    <div class="input">
                        <button mat-raised-button type="button" class="submit" style="width:110px;margin-top: 10%;"
                            (click)="findBookingInfo()">FIND BOOKING</button>
                    </div>

                </div>

                <div class="content" style="margin-top: 10px;">
                    <div class="input">
                        <label class="catlabel">Container Number</label>
                        <span>
                            <input type="text" formControlName="containerNumber" class="form-control inptwdth"
                            style="text-transform: uppercase;"  (keypress)="checkDigit($event)"
                            (keypress)="validate1($event)" (paste)="checkDigitPaste($event)"
                                [ngClass]="{'is-invalid': submitted && f['containerNumber'].errors}">
                        </span>
                        <div *ngIf="submitted && f['containerNumber'].errors" class="invalidFormat" style="width:180px">
                            <div *ngIf="f['containerNumber'].errors['required'] || f['containerNumber'].errors['maxlength'] || f['containerNumber'].errors['minlength'] || f['containerNumber'].errors['pattern']">Container Number is required and 11 chars, first 4 are letters and remaining are digits</div>
                        </div>
                    </div>
                    <div class="input">
                        <label class="catlabel">Vessel Name</label>
                        <span>
                            <input type="text" formControlName="vesselName" class="form-control inptwdth"
                                [ngClass]="{'is-invalid': submitted && f['vesselName'].errors}">
                        </span>
                        <div *ngIf="submitted && f['vesselName'].errors" class="invalidFormat">
                            <div *ngIf="f['vesselName'].errors['required']">Vessel Name is required</div>
                        </div>
                    </div>

                    <div class="input">
                        <label class="catlabel">Cut Off Date</label>
                        <span>
                            <input type="date" formControlName="cutOffDate" class="form-control inptwdth"
                                [ngClass]="{'is-invalid': submitted && f['cutOffDate'].errors}">
                        </span>
                        <div *ngIf="submitted && f['cutOffDate'].errors" class="invalidFormat">
                            <div *ngIf="f['cutOffDate'].errors['required']">Cut Off Date is required</div>
                        </div>
                    </div>

                </div>

                <div class="content" style="margin-top: 10px;">
                    <div class="input">
                        <label class="catlabel">ETA Date</label>
                        <span>
                            <input type="date" formControlName="etaDate" class="form-control inptwdth"
                                [ngClass]="{'is-invalid': submitted && f['etaDate'].errors}">
                        </span>
                        <div *ngIf="submitted && f['etaDate'].errors" class="invalidFormat">
                            <div *ngIf="f['etaDate'].errors['required']">ETA Date is required</div>
                        </div>
                    </div>
                    <div class="input">
                        <label class="catlabel">Service Provider</label>
                        <span>
                            <input type="text" class="drpdown col-5 p-5p" formControlName="serviceProvider"
                                class="form-control inptwdth"
                                [ngClass]="{'is-invalid': submitted && f['serviceProvider'].errors}">
                        </span>
                        <div *ngIf="submitted && f['serviceProvider'].errors" class="invalidFormat">
                            <div *ngIf="f['serviceProvider'].errors['required']">Service Provider is required</div>
                        </div>
                    </div>
                    <div class="input">
                        <label class="catlabel">Voyage Number</label>
                        <span>
                            <input type="text" formControlName="voyageNumber" class="form-control inptwdth"
                                [ngClass]="{'is-invalid': submitted && f['voyageNumber'].errors}">
                        </span>
                        <div *ngIf="submitted && f['voyageNumber'].errors" class="invalidFormat">
                            <div *ngIf="f['voyageNumber'].errors['required']">Voyage Number is required</div>
                        </div>
                    </div>

                </div>
                <div class="content" style="margin-top: 10px;">
                    <div class="input">
                        <label class="catlabel">Seal Number</label>
                        <span>
                            <input type="text" formControlName="sealNumber" class="form-control inptwdth" maxlength="20"
                            (keypress)="validate($event)" (paste)="onPaste1($event)"
                            [ngClass]="{'is-invalid': submitted && f['sealNumber'].errors}" >
                        </span>
                        <div *ngIf="submitted && f['sealNumber'].errors" class="invalidFormat">
                            <!-- <div *ngIf="f['sealNumber'].errors['required']">Seal Number is required</div> -->
                        </div>
                    </div>
                    <div class="input">
                        <label class="catlabel">Final Dest</label>
                        <span>
                            <input type="text" formControlName="finalDest" class="form-control inptwdth" maxlength="30"
                            (keypress)="routeVlidate($event)" (paste)="onPaste($event)"
                                [ngClass]="{'is-invalid': submitted && f['finalDest'].errors}">
                        </span>
                        <div *ngIf="submitted && f['finalDest'].errors" class="invalidFormat">
                            <!-- <div *ngIf="f['finalDest'].errors['required']">Final Dest is required</div> -->
                        </div>
                    </div>
                    <div class="input">
                        <label class="catlabel">Total Pallets</label>
                        <span>
                            <input type="text" formControlName="totalPallets" class="form-control inptwdth" maxlength="5" (keypress)="numberValidate($event)" (paste)="onPaste2($event)"
                                [ngClass]="{'is-invalid': submitted && f['totalPallets'].errors}">
                        </span>
                        <div *ngIf="submitted && f['totalPallets'].errors" class="invalidFormat">
                            <div *ngIf="f['totalPallets'].errors['required']">Total Pallets is required</div>
                            <div *ngIf="f['totalPallets'].errors['pattern']">Value must be a number between 0 and 99999</div>
                        </div>
                    </div>


                </div>
                <div class="content" style="margin-top: 10px;">
                    <div class="input">
                        <label class="catlabel">L1GR Module</label>
                        <span>
                            <input type="text" formControlName="L1GR" class="form-control inptwdth" maxlength="5" (keypress)="numberValidate($event)" (paste)="onPaste2($event)"
                                [ngClass]="{'is-invalid': submitted && f['L1GR'].errors}">
                        </span>
                        <div *ngIf="submitted && f['L1GR'].errors" class="invalidFormat">
                            <div *ngIf="f['L1GR'].errors['required']">L1GR Module is required</div> 
                            <div *ngIf="f['L1GR'].errors['pattern']">Value must be a number between 0 and 99999</div>
                        </div>
                    </div>
                    <div class="input">
                        <label class="catlabel">L3 Module</label>
                        <span>
                            <input type="text" class="drpdown col-5 p-5p" formControlName="L3" class="form-control inptwdth" maxlength="5" (keypress)="numberValidate($event)" (paste)="onPaste2($event)"
                              [ngClass]="{'is-invalid': submitted && f['L3'].errors}">
                        </span>
                        <div *ngIf="submitted && f['L3'].errors" class="invalidFormat">
                            <div *ngIf="f['L3'].errors['required']">L3 Module is required</div>
                            <div *ngIf="f['L3'].errors['pattern']">Value must be a number between 0 and 99999</div>
                        </div>
                    </div>
                    <div class="input">
                        <label class="catlabel">L5 Module</label>
                        <span>
                            <input type="text" class="drpdown col-5 p-5p" formControlName="L5" class="form-control inptwdth"  maxlength="5" (keypress)="numberValidate($event)" (paste)="onPaste2($event)"
                              [ngClass]="{'is-invalid': submitted && f['L5'].errors}">
                        </span>
                        <div *ngIf="submitted && f['L5'].errors" class="invalidFormat">
                            <div *ngIf="f['L5'].errors['required']">L5 Module is required</div>
                            <div *ngIf="f['L5'].errors['pattern']">Value must be a number between 0 and 99999</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

    </div>
    <div *ngIf="isFindBookingInfoEnabled">
        <app-notification-message [errorMessage]="errorMessage" class="notf"></app-notification-message>
        <div class="body">
            <div class="grid-agg">
                <ag-grid-angular #agGrid style="width:100%;height: 400px;" id="FVM-GRID" [gridOptions]="gridOptions"
                    class="ag-theme-balham" (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()"
                    [animateRows]="true" [defaultColDef]="defaultColDef" [columnDefs]="columnDefs"
                    [rowData]="displayRowData" [context]="context" [icons]="icons"
                    [overlayNoRowsTemplate]="noRowsTemplate" [enableCellTextSelection]="true" [ensureDomOrder]="true">
                </ag-grid-angular>
            </div>
        </div>
    </div>

    <div class="footerp cfooter">
        <label class="cancel" style="position: relative;
            margin-right: 2%;" (click)="onClick()"> CANCEL
        </label>

        <button mat-raised-button *ngIf="!isFindBookingInfoEnabled" class="submit" type="submit"
            style="display: inline;margin-right: 2%;" (click)="submitForm('active')">SAVE</button>
        <button mat-raised-button *ngIf="!isFindBookingInfoEnabled" class="submit" type="submit"
            style="display: inline;margin-right: 2%;" (click)="submitForm('submit')">CLOSED</button>
        <button mat-raised-button *ngIf="isFindBookingInfoEnabled" class="submit" type="submit"
            style="display: inline;margin-right: 2%;" (click)="addBookingInfo()">ADD</button>
    </div>

</div>